<template>
  <div class="container_box details_box_styles">
    <!--侧边广告位-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005069') }}</h2>
        </template>
        <Form>
          <Row>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1005042')" class="required_style_label" :label-width="90">
                <div class="jump_box">
                  <span class="jump_text" v-if="jumpTargetName" :title="jumpTargetName">{{ jumpTargetName }}</span>
                  <span class="not_filled_text" v-else>{{ $t('key1005048') }}</span>
                  <Button type="primary" size="small" @click="replaceBtn" class="ml15">
                    {{ jumpTargetName ? $t('key1005043') : $t('key1000669') }}
                  </Button>
                </div>
              </Form-item>
            </Col>
            <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
              <template v-for="item in multilingualNamesList">
                <template :slot="item.name">
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label-width="0">
                      <Upload
                        style="width: 400px;"
                        type="drag"
                        name="files"
                        :headers="headObj"
                        :action="fileApi"
                        :data="uploadData"
                        :show-upload-list="false"
                        :on-success="(value) => handelUploadSuccess(value, item)"
                        :format="['jpg', 'jpeg', 'png', 'gif', 'bmp']"
                        :max-size="20480"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize">
                        <div class="img_style" v-if="infoAdvertisingSpaceForm['imagePath_' + item.code]">
                          <img style="width: 80%; height: auto; display: inline-block" :src="setImgPath(infoAdvertisingSpaceForm['imagePath_' + item.code])" alt=""/>
                        </div>
                        <div v-else>
                          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                          <p class="upload_txt">
                            <span>{{ $t('key1005046') }}</span>
                            <span class="tips_txt">{{ $t('key1005079') }}</span>
                          </p>
                        </div>
                      </Upload>
                    </Form-item>
                  </Col>
                </template>
              </template>
            </languagesTabs>
          </Row>
        </Form>
      </Card>
    </div>
    <!--效果预览-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005049') }}</h2>
        </template>
        <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <div class="infoAdvertisingSpace_effect_box">
                <img class="banner_img" v-if="infoAdvertisingSpaceForm['imagePath_' + item.code]"
                  :src="setImgPath(infoAdvertisingSpaceForm['imagePath_' + item.code])" @error="setErrorImg($event)"/>
                <div v-else class="rendering_box">{{ $t('key1005044') }}</div>
              </div>
            </template>
          </template>
        </languagesTabs>
      </Card>
    </div>
    <!--底部操作按钮-->
    <div class="options_content">
      <Button class="mr15" @click="rotationChartCancelBtn">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" v-if="getPermission('ymsAdvertisement_save') || getPermission('ymsAdvertisement_update')"
        @click="rotationChartBtn">{{ $t('key1000555') }}</Button>
    </div>
    <!--更换活动弹窗设置-->
    <clickJumpModal ref="clickJump" @updateData="updateData"></clickJumpModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import clickJumpModal from "@/views/yms/components/marketingManage/clickJumpModal";
import languagesTabs from "@/components/common/languagesTabs.vue";

export default {
  name: "infoAdvertisingSpace",
  mixins: [Mixin],
  data() {
    return {
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      infoAdvertisingSpaceForm: {},
      jumpTargetName: '',
      jumpTargetType: null,
      jumpTargetValue: null,
      ymsAdvertisementId: null,
      advertisementTitle: ''
    };
  },
  created() {
    this.initMultilingualFields('infoAdvertisingSpaceForm', this.infoAdvertisingSpaceForm, ['imagePath_']);
    this.ymsAdvertisementId = this.$route.query.ymsAdvertisementId || null;
    if (this.ymsAdvertisementId) {
      this.getDetailsData();
    }
  },
  methods: {
    // 获取详情数据
    getDetailsData() {
      let v = this;
      v.axios.get(api.get_ymsAdvertisement_detail + `${v.ymsAdvertisementId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.ymsAdvertisementDetailBos;
          v.advertisementTitle = data.advertisementTitle;
          if (list.length > 0) {
            let obj = list[0];
            v.infoAdvertisingSpaceForm = v.handleMultilingualFormFields(obj, ['imagePath']);
            v.jumpTargetType = obj.jumpTargetType;
            v.jumpTargetValue = obj.jumpTargetValue;
            v.jumpTargetName = obj.jumpTargetName || '';
          }
        }
      });
    },
    // 上传图片成功
    handelUploadSuccess(response, item) {
      let v = this;
      if (response.code === 0) {
        let url = response.datas[0];
        v.infoAdvertisingSpaceForm['imagePath_' + item.code] = url;
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005038'));
        v.$forceUpdate();
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005039'));
      }
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 更换活动
    replaceBtn() {
      let obj = {
        jumpTargetType: this.jumpTargetType,
        jumpTargetValue: this.jumpTargetValue
      };
      this.$refs['clickJump'].initFun(obj);
    },
    // 取消按钮
    rotationChartCancelBtn() {
      this.$router.push('/advertisingManage');
    },
    // 保存按钮
    rotationChartBtn() {
      let v = this;
      let url = '';
      let method = '';
      let query = {
        advertisementTitle: v.advertisementTitle,
        orientationType: 2,
        status: 0, // 默认未启用
        ymsAdvertisementDetailBos: []
      };
      if (v.ymsAdvertisementId) {
        url = api.put_ymsAdvertisement_update;
        method = 'put';
        query.ymsAdvertisementId = v.ymsAdvertisementId;
      } else {
        url = api.post_ymsAdvertisement_save;
        method = 'post';
      }
      let newList = [];
      // 校验上传图片、点击跳转活动
      for (let j = 0; j < v.multilingualNamesList.length; j++) {
        let ele = v.multilingualNamesList[j];
        if (!v.infoAdvertisingSpaceForm['imagePath_' + ele.code] && ele.code === 'zh-CN') {
          v.$Message.warning(`${ele.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005074')}`);
          return false;
        }
      }
      if (v.jumpTargetType !== 3) {
        if (!v.jumpTargetValue) {
          v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005075')}`);
          return false;
        }
      }
      newList.push({
        imagePath: v.handleMultilingualSingleParam(v.infoAdvertisingSpaceForm, 'imagePath_'),
        jumpTargetType: v.jumpTargetType,
        jumpTargetValue: v.jumpTargetValue,
        jumpTargetName: v.jumpTargetName,
        sortNo: 1
      });
      query.ymsAdvertisementDetailBos = newList;
      v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.rotationChartCancelBtn();
        }
      });
    },
    // 获取更换活动的设置参数
    updateData(data) {
      let v = this;
      if (data) {
        let jumpTargetType = data.jumpTargetType;
        this.jumpTargetName = data.jumpTargetValue || '';
        // 活动
        if (jumpTargetType === 0) {
          data.activityList.map((ele) => {
            if (ele.ymsActivityPlanId === data.jumpTargetValue) {
              this.jumpTargetName = ele.activityTitle;
            }
          });
        }
        // 分类
        else if (jumpTargetType === 2) {
          data.ymsProductCategoryList.map((ele) => {
            if (ele.ymsProductCategoryId === data.jumpTargetValue) {
              this.jumpTargetName = ele.title;
            }
          });
        }
        this.jumpTargetType = data.jumpTargetType;
        this.jumpTargetValue = data.jumpTargetValue;
        v.$forceUpdate();
      }
    }
  },
  components: {
    languagesTabs,
    clickJumpModal
  }
};
</script>

<style lang="less" scoped>
.jump_box {
  display: flex;
  align-items: center;
  position: relative;
  top: 2px;

  .jump_text {
    display: inline-block;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 340px;
    font-size: 12px;
  }

  .not_filled_text {
    font-size: 12px;
    display: inline-block;
    color: #d00707;
  }
}

.infoAdvertisingSpace_effect_box {
  width: 228px;
  height: 70px;
  background: #FFFFFF;
  border-radius: 4px;
  margin-bottom: 60px;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1500);

  .banner_img {
    display: inline-block;
    width: auto;
    height: 100%;
  }

  .rendering_box {
    display: inline-block;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F7F7F7;
    font-size: 14px;
  }
}

.options_content {
  box-shadow: 0px -3px 10px 0px #c9cbce;
  position: fixed;
  min-width: 100%;
  z-index: 10;
  background-color: #fff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 15px;
}

.img_style {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 228px;
  max-height: 70px;
}
</style>